import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['select', 'dateField', 'dateInput'];

  selectTarget!: HTMLSelectElement;
  dateFieldTarget!: HTMLElement;
  dateInputTarget!: HTMLInputElement;

  connect() {
    this.toggleDate();
  }

  toggleDate() {
    const show = this.selectTarget.value === 'available_soon';
    this.dateFieldTarget.style.display = show ? '' : 'none';
    if (!show) {
      this.dateInputTarget.value = '';
    }
  }
}
